import React from 'react'

function Footer() {
    return (
        <footer>
            <br />
            <br />
            <br />
            <p> Designed by: Virginia Scirrotto™</p>
            <p>All Rights Reserved © 2020</p>
        </footer>    
    )
}

export default Footer